import React from 'react'
import PropTypes from 'prop-types'
import QRCode from 'qrcode.react'

import withOrderFormAndVendor from '@/checkout-instore-legacy/order/withOrderFormAndVendor'
import { getOrderFormId } from '@/checkout-instore-legacy/utils/orderFormUtils'

const QRCodeGenerator = ({ orderForm, ...props }) =>
  orderForm && <QRCode value={getOrderFormId(orderForm)} {...props} />

QRCodeGenerator.propTypes = {
  orderForm: PropTypes.object,
}

export default withOrderFormAndVendor(QRCodeGenerator)
